// extracted by mini-css-extract-plugin
export default {"content":"ElectricityRecord_content__Ywf5D","tabs":"ElectricityRecord_tabs__Hraz7"};